import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, CountryDetail, KeyValues3, KeyValues5, KeyValues10, KeyValueSet, LocalService, StatusWithId, ToolPricingInitialization, Wrapper10, Wrapper15, KeyValues15 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class CountryManagementService {
  private controllerName = service_controllers_methods.country.controller;
  private methods = service_controllers_methods.country.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public ensureCountryCodes(isForceUpdate?: boolean) {
    if (this.localService.currentTimeZones.length == 0) {
      this.getCountryCodesToDisplay(false).subscribe(result => {
        this.localService.countryCodes = result;
      });

      this.getCountryByTimeZone().subscribe(result => {
        this.localService.currentTimeZones = result;
      });
    } else if (isForceUpdate) {
      this.getCountryCodesToDisplay(false).subscribe(result => {
        this.localService.countryCodes = result;
      });
    }
  }

  onCountryCodeLoaded() {
    setTimeout(() => {
      let elements = document.getElementsByClassName('on_country_code_loaded');
      if (elements != undefined && elements != null) {
        for (var i = 0; i < elements.length; i++) {
          let element = elements[i] as HTMLElement;
          element.click();
        }
      }
    }, 100);
  }

  getCountryCodesToDisplay(isSpinner: boolean = true): Observable<KeyValues15[]> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCountryCodesToDisplay, body, isSpinner);
  }

  getContactCode(strCountryId: string): Observable<CountryDetail> {
    let body = {
      sel: this.localService.getSelected(),
      strCountryId: strCountryId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetContactCode, body);
  }

  getCountryCode(strCountryId: string): Observable<KeyValueSet> {
    let body = {
      strCountryId: strCountryId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCountryCode, body);
  }

  setCountryCode(strCountryId: string) {
    this.getCountryCode(strCountryId).subscribe(result => {
      this.localService.selected.countryCode = result.value;
    });
  }

  public getCountries(): Observable<KeyValues5[]> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCountries, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): Observable<StatusWithId> {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public saveCountry(wrapper: Wrapper15): Observable<StatusWithId> {
    let body = {
      wrapper: wrapper,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveCountry, body);
  }

  public getCountry(id: string): Observable<Wrapper15> {
    let body = {
      strId: id,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCountry, body);
  }

  public getToolPricingInitialization(id: string, isEditMode: boolean): Observable<ToolPricingInitialization> {
    let body = {
      dt: { key: id, v1: isEditMode ? "1" : "0" } as KeyValues3,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetToolPricingInitialization, body);
  }

  public getCountryByTimeZone(): Observable<KeyValues3[]> {
    let body = {
      dt: { v1: this.localService.getUtcOffset().toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCountryByTimeZone, body);
  }

  public getCountryPricing(id: string, isEditMode: boolean): Observable<KeyValues5[]> {
    let body = {
      dt: { key: id, v1: isEditMode ? "1" : "0" } as KeyValues3,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetCountryPricing, body);
  }

  public saveCountryPricing(id: string, data: KeyValues5[]): Observable<StatusWithId[]> {
    let body = {
      strId: id,
      sel: this.localService.getSelected(),
      dt: data
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveCountryPricing, body);
  }
}
